import { render, staticRenderFns } from "./Style4.vue?vue&type=template&id=4f66ab6b"
import script from "./Style4.vue?vue&type=script&lang=js"
export * from "./Style4.vue?vue&type=script&lang=js"
import style0 from "./Style4.vue?vue&type=style&index=0&id=4f66ab6b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports